import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SubscriptionLike } from 'rxjs';
import { serviceConstants } from 'src/app/constants/service.constants';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { FileInfo } from '../../document-summary/custom-single-doc/custom-single-doc.component';
import { FilePreviewComponent } from '../../document-summary/file-preview/file-preview.component';
import { EmailComposeComponent } from '../email-compose/email-compose.component';
import { CommonService } from 'src/app/services/common.service';

import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-email-read',
  templateUrl: './email-read.component.html',
  styleUrls: ['./email-read.component.scss']
})
export class EmailReadComponent implements OnInit, OnDestroy {
  subFilePost: SubscriptionLike;
  subGetData: SubscriptionLike;
  subGetData1: SubscriptionLike;

  ApplicationID: string;
  ModuleID: string;
  @Input() MessageID: string;
  @Input() Folder: "I" | "O";
  @Input() Permission: any;
  @Input() FormEmailId: any;
  MailData = new MsgInfo();
  dateFormat = localStorage.getItem("_Dateformate") ?? 'DD MMM YYYY';
  datetimeFormat = this.dateFormat + ' ' + localStorage.getItem("_Timeformate");
  timeFormat: any = localStorage.getItem("_Timeformate");
  MsgBodyForm: UntypedFormGroup;

  msgBody: string = "";
  @Output() RefreshCount: EventEmitter<any> = new EventEmitter();

  editorInit: Record<string, any> | undefined = {
    base_url: '/tinymce', readonly: true,
    suffix: '.min',
    statusbar: false,
    toolbar: false,
    menubar: false,
    height: 'calc(50vh - 70px) !important',
    paste_data_images: false
  };

  expandEmailURL: SafeUrl;
  activeEmailFolder: "I" | "O";
  toEmail_1st: string = ""
  ccEmail_1st: string = ""
  bccEmail_1st: string = ""
  toEmailsRem: string[] = []
  ccEmailsRem: string[] = []
  bccEmailsRem: string[] = []
  showTO: boolean = false;
  showCC: boolean = false;
  showBCC: boolean = false;
  showSubject: boolean = false;
  SubjectMore: boolean = false;
  downloadPDFUrl: String = "";
  baseURL: string = "";
  permission: string = "";
  formEmailId:string ="";
  constructor(
    public apiUrlservice: ApidataRequestService,
    private datePipe: DatePipe,
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private commonService: CommonService
  ) {
    this.baseURL = serviceConstants.baseUrl;
  }

  ngOnDestroy(): void {
    if (this.subGetData) this.subGetData.unsubscribe();
    if (this.subGetData1) this.subGetData1.unsubscribe();
    if (this.subFilePost) this.subFilePost.unsubscribe();
  }
  ngOnInit(): void {
    this.activeEmailFolder = this.Folder;
   this.permission = this.Permission;
   this.formEmailId= this.FormEmailId;
    this.initialize(this.activeEmailFolder, this.MessageID);
    this.MsgBodyForm = new UntypedFormGroup({ msgBody: new UntypedFormControl("") });
    this.downloadPDFUrl = serviceConstants.apiURL + "api/File/DownloadMailWithoutAtt?emailMsgID=" + this.MessageID;
  }

  initialize(emailFolder: "I" | "O", messageID?: string) {
  
    this.activeEmailFolder = emailFolder;
    if (messageID) {
      this.expandEmailURL = this.baseURL + "/expandemail?msgID=" + messageID;
      this.downloadPDFUrl = serviceConstants.apiURL + "api/File/DownloadMailWithoutAtt?emailMsgID=" + messageID;
      this.getMessage(messageID);
    }
  }

  getMessage(MessageID: any) {
    this.subGetData = this.apiUrlservice.getData("api/Correspondence/GetMailInfo?MsgID=" + MessageID).subscribe(result => {
      if (result.Status) {
        this.MailData = result.Data;
        setTimeout(() => {
          this.MsgBodyForm.controls["msgBody"].disable();
        }, 500);

        this.MsgBodyForm.controls["msgBody"].setValue(this.MailData.MsgBody);
        this.MailData.attNames = "";
        let fileNamesArray: string[] = [];
        this.MailData.Attachments.forEach(element => {
          fileNamesArray.push(element.FileName + element.FileExt);
        });
        this.MailData.attCount = fileNamesArray.length;
        this.msgBody = this.MsgBodyForm.controls["msgBody"].value;
        this.MailData.attNames = fileNamesArray.join(', ');
        this.toEmailsRem = this.MailData.To.split(',');
        this.ccEmailsRem = this.MailData.CC.split(',');
        this.bccEmailsRem = this.MailData.BCC.split(',');
        this.toEmail_1st = this.toEmailsRem[0];
        this.ccEmail_1st = this.ccEmailsRem[0];
        this.bccEmail_1st = this.bccEmailsRem[0];
        this.toEmailsRem.splice(this.toEmailsRem.indexOf(this.toEmail_1st), 1);
        this.ccEmailsRem.splice(this.ccEmailsRem.indexOf(this.ccEmail_1st), 1);
        this.bccEmailsRem.splice(this.bccEmailsRem.indexOf(this.bccEmail_1st), 1);
      } else {
        this.MailData = new MsgInfo();
        this.toEmailsRem = [];
        this.ccEmailsRem = [];
        this.bccEmailsRem = [];
      }
    });
  }

  showMore(type) {
    switch (type) {
      case 'TO':
        this.showTO = !this.showTO;
        break;
      case "CC":
        this.showCC = !this.showCC;
        break;
      case "BCC":
        this.showBCC = !this.showBCC;
        break;
        case "Subject":
          if(!this.SubjectMore)
          {
        this.showSubject = !this.showSubject;
        this.SubjectMore= true;
          }
          else 
          {
            this.showSubject = false;
            this.SubjectMore= false;
          }
        break;
      default:
        this.showTO = false;
        this.showCC = false;
        this.showBCC = false;
        this.showSubject =false;
        this.SubjectMore = false;
    }
  }
 

  downloadMail() {
    this.subGetData1 = this.apiUrlservice.getData("api/File/DownloadMailWithoutAtt?emailMsgID=" + this.MessageID).subscribe(result => {

      if (result) {

      }
    })
  }


  reply(isReplyAll) {  
    var err: any = [];
    // if (this.FormEmailId != null && this.FormEmailId != "" && this.FormEmailId != undefined) {
    let modalRef = this.modalService.open(EmailComposeComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: !isReplyAll ? 'reply' : 'reply-all',
      content: { ApplicationID: this.MailData.ApplicationID, ModuleID: this.MailData.ModuleID,SubModule: this.MailData.SubModule, MailFolder: this.activeEmailFolder, EmailMsgObj: this.MailData,PKRRFMsgID: this.MailData.MsgID, MailType: !isReplyAll ? 'reply' : "reply-all" }
    }
    modalRef.result.then(result => {    
      this.RefreshCount.emit("");
    })
  // }
  // else {
  //   err.push('Outgoing emails related to correspondence for this organization is not configured');
  //   this.commonService.ValidationBanner(err);
  // }
  }

  forward() {
    var err: any = [];
    // if (this.FormEmailId != null && this.FormEmailId != "" && this.FormEmailId != undefined) {
    let modalRef = this.modalService.open(EmailComposeComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'forward',
      content: { ApplicationID: this.MailData.ApplicationID, ModuleID: this.MailData.ModuleID,SubModule: this.MailData.SubModule, EmailMsgObj: this.MailData, PKRRFMsgID: this.MailData.MsgID, MailType: "forward" }
    }
    modalRef.result.then(result => {  
      this.RefreshCount.emit("");
    })
  // }
  // else {
  //   err.push('Outgoing emails related to correspondence for this organization is not configured');
  //   this.commonService.ValidationBanner(err);
  // }
  }

  clearChecks() {
    this.MailData.Attachments.forEach(element => {
      element.IsChecked = false;
    });
  }

  downloadAtts(isDownloadAll) {
    let dwnldAtt: DownloadAtt = new DownloadAtt();
    dwnldAtt.EmailMsgId = this.MessageID;
    dwnldAtt.IsDownloadAll = isDownloadAll;
    dwnldAtt.EmailSubject = this.MailData.Subject
    if (!isDownloadAll) {
      this.MailData.Attachments.forEach(element => {
        if (element.IsChecked)
          dwnldAtt.FileIDList.push(element.FileID);
      });
    }
    else {
      this.MailData.Attachments.forEach(element => {
        dwnldAtt.FileIDList.push(element.FileID);
      });
    }

    if (isDownloadAll) {
      this.subFilePost = this.apiUrlservice.filePost("api/File/DownloadAllAttachments", dwnldAtt).subscribe(result => {
        if (result) {
          let downloadUrl = serviceConstants.apiURL + "api/File/DownloadFile?type=temp" + "&id=" + result.FileID;
          window.open(downloadUrl);
        }
      })
    }
    else {
      let downloadUrl = serviceConstants.apiURL + "api/File/DownloadFile?type=temp" + "&id=" + dwnldAtt.FileIDList[0];
      window.open(downloadUrl);
    }
  }


  expandEmail() {
    window.open(`${this.expandEmailURL}`, 'MaximizeEmail', 'width=800, height=500');
  }

ViewFile(fileID,fileName)
{
this.commonService.previewFile(fileID,fileName,"main"); 

}

downloadFile(ID) {
  let url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + ID;
  window.open(url);  
}

  previewFile(fileID, fileName, fileExt) {
    if (fileExt != ".ics") {
      let options = {
        size: 'lg w-70',
        backdrop: false,
        windowClass: "right",

      };
      let modalRef = this.modalService.open(FilePreviewComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-llg modal-full-height modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        content: { FileID: fileID, Type: "main", FileName: fileName }
      }
    }
  }

}

export class DownloadAtt {
  public EmailMsgId: string
  public IsDownloadAll: boolean
  public FileIDList: string[] = []
  public EmailSubject: string
}

export class MsgInfo {
  public ApplicationID: string
  public ModuleID: string
  public SubModule: string
  public PKRRFMsgID:string
  public MsgID:string
  public From: string
  public To: string
  public CC: string
  public BCC: string
  public Subject: string
  public MsgDate: string | null
  public IsHighImp: boolean
  public Attachments: FileInfo[]
  public attNames: string
  public attCount: number
  public MsgBody: string
  public IsReplied: boolean
  public MsgDateString: string
}
